import { Entity } from "./Entity";

export type DumpsterEventType = "dropoff" | "pickup";

export const dumpsterEventTypeToText: Record<DumpsterEventType, string> = {
  dropoff: "Dropoff",
  pickup: "Pickup",
};

export interface DumpsterLocationHistory extends Entity {
  dumpsterId: string;
  eventType: DumpsterEventType;
  orderId?: string;
  storageYardId?: string;
  address: string;
  city: string;
  zip: string;
  createdAt: string;
}
